var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6663H8M7.33333 4.1677C7.75949 4.05801 8.20627 3.99967 8.66667 3.99967C11.6122 3.99967 14 6.38749 14 9.33301C14 11.5713 12.6212 13.4875 10.6667 14.2787M3.66667 8.66634H6.33333C6.6431 8.66634 6.79799 8.66634 6.92679 8.69196C7.45571 8.79717 7.86917 9.21063 7.97438 9.73955C8 9.86835 8 10.0232 8 10.333C8 10.6428 8 10.7977 7.97438 10.9265C7.86917 11.4554 7.45571 11.8688 6.92679 11.9741C6.79799 11.9997 6.6431 11.9997 6.33333 11.9997H3.66667C3.3569 11.9997 3.20201 11.9997 3.07321 11.9741C2.54429 11.8688 2.13083 11.4554 2.02562 10.9265C2 10.7977 2 10.6428 2 10.333C2 10.0232 2 9.86835 2.02562 9.73955C2.13083 9.21063 2.54429 8.79717 3.07321 8.69196C3.20201 8.66634 3.3569 8.66634 3.66667 8.66634ZM2.66667 3.66634V8.66634H7.33333V3.66634C7.33333 2.37768 6.28866 1.33301 5 1.33301C3.71134 1.33301 2.66667 2.37768 2.66667 3.66634Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.d061a1e4681a3f3f76c80e6c07e9574f.svg";
export { ForwardRef as ReactComponent };